module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":{"first":"First name","last":"Last name"},"email":"Email address","phone":"Phone number","country":"Country","comments":"Comments"},"sl":{"name":{"first":"Ime","last":"Priimek"},"email":"Email naslov","phone":"Telefonska številka","country":"Država","comments":"Komentarji"}}')
  delete Component.options._Ctor
}
